import VueRouter, { RawLocation } from 'vue-router'

const getRoomLocation = (roomId: string): RawLocation => ({
  name: 'room',
  params: { roomId },
})

const getAbsoluteRoomLink = (router: VueRouter, roomId: string) => {
  const { href } = router.resolve(getRoomLocation(roomId))
  const origin = process.env.VUE_APP_NATIVE === 'true'
    ? (process.env.VUE_APP_SHARE_ORIGIN || 'https://oneword.economicusgame.com')
    : window.location.origin

  return new URL(href, origin).toString()
}

export { getAbsoluteRoomLink, getRoomLocation }
